<template>
  <div class="attribution-analysis-main-container" v-loading="loading.initLoading">
    <div class="header">
      <div class="left">
        <span class="back" v-if="!!formComponent.boardId" @click="handleBack">
          <icon name="chevron-left" />
        </span>
        <!--<div class="tit">{{ headTitle }}</div>-->
        <t-breadcrumb style="margin-right: 20px">
          <t-breadcrumb-item>{{ headTitle }}</t-breadcrumb-item>
        </t-breadcrumb>
        <div class="mdRemod">
          <img :src="bookHref" style="margin-right: 5px" alt="" />
          <a href="https://docs.qq.com/doc/DS2R6Q3JFckZnekdl" target="_blank">说明文档</a>
        </div>
        <!--<new-guide-trigger class="new-guide-trigger" @click="handleStartGuide"></new-guide-trigger>-->
      </div>
      <div class="right">
        <t-button variant="outline" @click="handleOpenSave">
          <icon name="save" slot="icon" />
          保存至看板
        </t-button>
      </div>
    </div>

    <my-card v-loading="loading.fetchFormOption">
      <div slot="header" style="display: flex; justify-content: space-between">
        <div class="left">
          <div class="title">分析条件</div>
        </div>
        <div class="right">
          <t-switch size="small" v-model="showAnalysisConditions"></t-switch>
          <span style="margin-left: 10px; font-size: 12px">{{ showAnalysisConditions ? '展开' : '收起' }}</span>
        </div>
      </div>

      <div class="form" v-show="showAnalysisConditions">
        <target-event
          ref="targetEvent"
          v-model="formValue.targetEvent"
          :event-list="formOption.eventList"
          :condition-property-options="formOption.conditionPropertyOptions"
          :condition-operator-options="formOption.conditionOperatorOptions"
          :all-event-event-property-list="formOption.allEventProperty"
        />

        <to-attribute-event
          ref="attributeEvent"
          v-model="formValue.toAttributeEvent"
          :pre-associated-event="formValue.preAssociatedEvent"
          :event-list="formOption.eventList"
          :condition-property-options="formOption.conditionPropertyOptions"
          :condition-operator-options="formOption.conditionOperatorOptions"
          :all-event-event-property-list="formOption.allEventProperty"
        />

        <process-event
          ref="processEvent"
          v-model="formValue.preAssociatedEvent"
          :target-event="formValue.targetEvent"
          :to-attribute-event="formValue.toAttributeEvent"
          :event-list="formOption.eventList"
          :condition-property-options="formOption.conditionPropertyOptions"
          :condition-operator-options="formOption.conditionOperatorOptions"
          :all-event-event-property-list="formOption.allEventProperty"
        />

        <div class="new-guide-step-5">
          <form-item label="全局筛选" class="global-filter">
            <div style="display: flex; align-items: center">
              <span class="global-filter-index">1</span>
              <t-input
                v-model="globalFilterTitle"
                style="margin-right: 12px; width: 200px"
                @blur="handleGlobalFilterTitleChange"
              ></t-input>
              <t-button @click="handleAddGlobalFilterItem" variant="outline" style="font-size: 12px">
                <icon name="add" slot="icon"></icon>
                筛选项
              </t-button>
            </div>

            <template v-slot:extraLine v-if="formValue.conditionModels && formValue.conditionModels.length">
              <div class="filter">
                <ConditionFilter
                  style=""
                  v-if="formOption.conditionPropertyOptions.length && formOption.conditionOperatorOptions.length"
                  :filter-type.sync="formValue.connectors"
                  :filter-list="formValue.conditionModels"
                  :condition-operator-options="formOption.conditionOperatorOptions"
                  :condition-property-options="formOption.conditionPropertyOptions"
                />
              </div>
            </template>
          </form-item>

          <!--          <people-group-select v-model="formValue.packageId" />-->
        </div>

        <form-item class="row-item new-guide-step-3" label="归因方式" tips="归因结果的计算方式">
          <t-select v-model="formValue.attributionType" placeholder="请选择" style="width: 208px">
            <t-option
              v-for="item in formOption.typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></t-option>
          </t-select>
        </form-item>

        <form-item
          class="row-item new-guide-step-4"
          label="归因窗口期"
          tips="【目标事件】往前回溯【待归因事件】与【前项关联事件】的时间窗口"
        >
          <div class="window-period-item">
            <t-select
              @change="handleChangeWindowPeriod"
              v-model="windowPeriodType"
              placeholder="请选择"
              style="width: 208px"
            >
              <t-option
                v-for="item in formOption.dateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></t-option>
            </t-select>

            <template v-if="windowPeriodType === formOption.dateOptions[1].value">
              <t-input-number
                theme="column"
                :decimalPlaces="0"
                :min="1"
                :max="formValue.windowUnit === 'day' ? 365 : 360"
                v-model="formValue.windowPeriod"
                placeholder="请输入内容"
                style="margin: 0 10px; max-width: 100px"
              />
              <t-select
                v-model="formValue.windowUnit"
                placeholder="请选择"
                style="width: 100px"
                @change="handleChangeWindowUnit"
              >
                <t-option label="天" value="day"></t-option>
                <t-option label="小时" value="hour"></t-option>
              </t-select>
            </template>
          </div>
        </form-item>

        <form-item
          class="row-item"
          label="计算其他转化"
          tips="也计算达成目标事件的未选中待归因事件的总转化量与贡献，是总计值，帮助判断用户选中的待归因事件是否为重点归因事件"
        >
          <t-radio-group v-model="formValue.isDirectTransform" class="is-direct-transform-radio">
            <t-radio :value="1">计算</t-radio>
            <t-radio :value="-1">不计算</t-radio>
          </t-radio-group>
        </form-item>

        <div style="margin-top: 20px">
          <t-button :loading="loading.fetchData" @click="handleQueryClick" style="font-size: 12px; width: 80px">
            查询
          </t-button>
          <t-button variant="outline" @click="handleReset" style="font-size: 12px; width: 80px">重置</t-button>
        </div>
      </div>
    </my-card>

    <my-card class="section-table">
      <div slot="header" class="title">
        <div class="title-left">分析列表</div>
        <div class="title-right">
          <date-range-picker
            v-model="formValue.dateInfo"
            :picker-options="formOption.datePickerOptions"
          ></date-range-picker>
          <icon name="download" style="margin-left: 22px" @click="exportData" />
        </div>
      </div>
      <div v-if="tableData.length || loading.fetchData" v-loading="loading.fetchData" class="table" style="">
        <attribution-analysis-table
          :list-data="tableData"
          :analysis-model-config="formValue"
          :event-target-column="eventTargetColumn"
          :condition-property-options="formOption.conditionPropertyOptions"
        ></attribution-analysis-table>
      </div>
      <noData v-else />
    </my-card>

    <save-action
      v-if="showBookmarkModal"
      :loading="loading.submitting"
      :board-info="boardInfo"
      :form-data-component="formComponent"
      :form-data-bookmark="formBookmark"
      @onClose="showBookmarkModal = false"
      @onSaveBookmark="handleSaveBookmark"
      @onSaveComponent="handleSaveComponent"
    ></save-action>
  </div>
</template>

<script>
import dayjs from 'dayjs';

import lodash, { pick } from 'lodash';
import XLSX from 'xlsx';
import FormItem from './components/form-item.vue';
import TargetEvent from './components/target-event.vue';
import ToAttributeEvent from './components/to-attribute-event.vue';
import ConditionFilter from '@/components/analysis/condition-filter.vue';
import PeopleGroupSelect from './components/people-group-select.vue';
import AttributionSelect from './components/attribution-select.vue';
import AttributionAnalysisTable from './components/table.vue';
import DateRangePicker from '@/components/analysis/date-range-picker.vue';
import noData from '@/components/common/no-data-card.vue';
import SaveAction from './components/save.vue';
import bookHref from '@/assets/images/booklistHref.png';
import {
  getAllEventProperty,
  getAllProperty,
  getEnumType,
  getEventList,
  getConditionOperator,
  getPollingId,
  getTableData,
  saveAsBookmark,
  getBookmarkDetail,
  getTargetColumn,
} from '@/api/analysis/custom-analysis';
import { createComponent, getBoardDetail, getComponentList, modifyComponent } from '@/api/analysis/custom-overview';

import { PollingAction } from '@/utils/helper';
import mixinGuide from '@/minxins/new-guide';
import ProcessEvent from './components/process-event.vue';

const DATE_OPTIONS = [
  {
    label: '当天',
    value: 'nowDay',
  },
  {
    label: '自定义',
    value: 'custom',
  },
];

const DEFAULT_DATE = {
  timeType: 'static',
  timeDimension: 'day',
  startTime: dayjs().subtract(7, 'day').format('YYYYMMDD'),
  endTime: dayjs().subtract(1, 'day').format('YYYYMMDD'),
};

export default {
  name: 'attributionAnalysis',
  mixins: [mixinGuide],
  components: {
    ProcessEvent,
    FormItem,
    TargetEvent,
    ToAttributeEvent,
    ConditionFilter,
    AttributionSelect,
    AttributionAnalysisTable,
    noData,
    PeopleGroupSelect,
    DateRangePicker,
    SaveAction,
  },
  data() {
    return {
      showAnalysisConditions: true,

      bookHref,
      loading: {
        initLoading: false,
        query: false,
        submitting: false,
        fetchData: false,
        fetchBookmark: false,
        fetchFormOption: false,
      },

      refreshCount: 0,
      showBookmarkModal: false,
      polling: null, //  轮询查询对象

      //  表单选项
      formOption: {
        typeOptions: [],
        dateOptions: DATE_OPTIONS,
        eventList: [],
        conditionPropertyOptions: [
          // { propertyType: '', propertyName: 'channel', propertyDesc: '渠道', propertyDataType: 'string' },
        ],
        conditionOperatorOptions: [
          // { type: 'eq', desc: '等于', javaType: 'string', canMore: 2 },
        ],
        allEventProperty: [],

        datePickerOptions: {
          disabledDate(time) {
            return dayjs(time).isAfter(dayjs(new Date()), 'day');
          },
        },

        targetColumnMap: {},
      },

      windowPeriodType: DATE_OPTIONS[0].value,

      formValue: {
        // 书签id
        id: undefined,
        attributionType: undefined,
        windowPeriod: 1,
        windowUnit: 'day',

        //  目标事件
        targetEvent: {
          eventName: '',
          eventChineseName: '',
          eventTargetColumn: {
            type: '',
            calcType: '',
          },
          conditionModels: [],
          connectors: 'and',
        },
        // 待归因事件
        toAttributeEvent: [
          {
            eventName: '',
            eventChineseName: '',
            groupBy: '',
            conditionModels: [],
            connectors: 'and',
          },
        ],
        // 过程事件
        preAssociatedEvent: [],

        isDirectTransform: 1, // 1: 是； -1: 否
        connectors: 'and',
        conditionModels: [],
        packageId: '',
        dateInfo: DEFAULT_DATE,
      },

      globalFilterTitle: '全体用户',
      canAutoModifyGlobalFilterTitle: true,

      formBookmark: {
        id: '',
        bookmarkName: '',
        remark: '',
      },
      formComponent: {
        id: '',
        name: '',
        boardId: '',
      },
      boardInfo: {},

      currentPage: 1,
      pageSize: 10, // 一页有多少条数据
      totalCount: 0, // 总共的条数
      pageSizeList: [10, 20, 50, 100, 300, 500], // 可供选择的每页大小
      tableData: [],

      isDoReset: false,
      resetData: {
        formValue: {
          attributionType: undefined,
          windowPeriod: 1,
          windowUnit: 'day',

          targetEvent: {
            eventName: '',
            eventChineseName: '',
            eventTargetColumn: {
              type: '',
              calcType: '',
            },
            conditionModels: [],
            connectors: 'and',
          },
          toAttributeEvent: [
            {
              eventName: '',
              eventChineseName: '',
              groupBy: '',
              conditionModels: [],
              connectors: 'and',
            },
          ],
          preAssociatedEvent: [],

          isDirectTransform: 1, // 1: 是； -1: 否
          connectors: 'and',
          conditionModels: [],
          packageId: '',
          dateInfo: DEFAULT_DATE,
        },
        windowPeriodType: DATE_OPTIONS[0].value,
      },
    };
  },

  computed: {
    headTitle() {
      return this.formComponent.name || this.formBookmark.bookmarkName || '归因分析';
    },
    getCurrentPageData() {
      const { currentPage, pageSize, tableData } = this.$data;
      const start = (currentPage - 1) * pageSize;
      const end = currentPage * pageSize;
      return tableData.slice(start, end);
    },
    columnNameAndJavaTypeMap() {
      return this.formOption.conditionPropertyOptions.reduce((total, item) => {
        total[item.propertyName] = item.propertyDataType;
        return total;
      }, {});
    },
  },
  asyncComputed: {
    async eventTargetColumn() {
      const { eventName, eventTargetColumn } = this.formValue.targetEvent;
      const { targetColumnMap } = this.formOption;
      if (!eventName) {
        return { type: { value: '', label: '' }, calc: { value: '', label: '' } };
      }

      if (!targetColumnMap[eventName]) {
        const result = await getTargetColumn({ params: { events: eventName } });
        this.formOption.targetColumnMap[eventName] = result[eventName] || [];
      }

      const columnList = targetColumnMap[eventName];

      if (!columnList || !columnList.length) {
        return { type: { value: '', label: '' }, calc: { value: '', label: '' } };
      }

      const { type, calcType } = eventTargetColumn || [];
      const { desc, calcList = [] } = columnList.find(op => op.type === type) || {};
      const value = {
        type: { value: type, label: desc },
        calc: { value: '', label: '' },
      };
      if (calcType && calcList && calcList.length) {
        const { calcDesc } = calcList.find(op => op.calcType === calcType) || {};
        value.calc.label = calcDesc;
        value.calc.value = calcType;
      }
      return value;
    },
  },

  watch: {
    $route() {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('routerReload'));
      }, 100);
    },
    'formValue.conditionModels': {
      handler() {
        if (!this.canAutoModifyGlobalFilterTitle) {
          return;
        }
        this.globalFilterTitle =
          this.formValue.conditionModels
            .map(item => item.value)
            .filter(item => !!item)
            .join(',') || '全体用户';
      },
      deep: true,
    },
    'formValue.dateInfo': {
      handler() {
        if (this.tableData && this.tableData.length && !this.loading.fetchData && !this.isDoReset) {
          this.handleQueryClick();
        }
      },
      deep: true,
    },
  },

  async created() {
    this.initUrlParams();
    this.initData();
  },

  beforeDestroy() {
    if (this.polling) {
      this.polling.stop();
    }
  },

  methods: {
    initUrlParams() {
      if (this.$route.query.bookmarkId) {
        this.formBookmark.id = this.$route.query.bookmarkId;
      }
      if (this.$route.query.compId) {
        this.formComponent.id = this.$route.query.compId;
      }
      if (this.$route.query.boardId) {
        this.formComponent.boardId = this.$route.query.boardId;
      }
    },

    async initData() {
      try {
        this.loading.initLoading = true;
        try {
          await this.getFormOption();
        } catch (e) {
          this.$message.warning((e && e.message) || '系统异常，请稍后重试');
        }

        if (this.formBookmark.id) {
          await this.fetchBookmarkDetail();
          this.handleGetData();
        }
        if (this.formComponent.id) {
          await this.fetchComponentInfo();
          this.handleGetData();
        }
        if (this.formComponent.boardId) {
          await this.fetchBoardInfo();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading.initLoading = false;
        // 判断是否出现新手指引
        // setTimeout(() => {
        //   this.checkGuide();
        // }, 20);
      }
    },

    async getFormOption() {
      await new Promise(resolve => {
        const allFinished = [0, 0, 0, 0];
        this.loading.fetchFormOption = true;

        const loadingStatus = () => Math.min(...allFinished) === 0;

        getEnumType({ params: { enumType: 'attributionType' } })
          .then(res => {
            this.formOption.typeOptions = res.map(item => ({
              label: item.name,
              value: item.code,
              ...item,
            }));
            this.formValue.attributionType = this.formOption.typeOptions[0].value;
          })
          .finally(() => {
            allFinished[0] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });

        getEventList({ params: { getType: 'all' } })
          .then(res => {
            this.formOption.eventList = res || [];
          })
          .finally(() => {
            allFinished[1] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });

        getAllProperty({ params: { hasData: 1, isVisible: 1 } })
          .then(res => {
            this.formOption.conditionPropertyOptions = (res.list || []).map(item => ({
              propertyType: item.propertyType,
              propertyName: item.name,
              propertyDesc: item.chineseName,
              propertyDataType: item.javaType,
              name: item.name,
              propertyValueTipVOList: item.propertyValueTipVOList,
            }));
          })
          .finally(() => {
            allFinished[2] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });

        getConditionOperator()
          .then(res => {
            this.formOption.conditionOperatorOptions = res;
          })
          .finally(() => {
            allFinished[3] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });
      });
      await this.getAllEventProperty();
    },

    async getAllEventProperty() {
      const res = (await getAllEventProperty({})) || [];
      this.formOption.allEventProperty = res.map(item => ({
        eventName: item.eventName,
        propertyList: (item.propertyList || []).map(i => ({
          propertyName: i.name,
          propertyDesc: i.chineseName,
          propertyType: i.propertyType,
          propertyDataType: i.javaType,
        })),
      }));
    },

    handleOpenSave() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }
      this.showBookmarkModal = true;
    },

    async fetchBookmarkDetail() {
      const { id } = this.formBookmark;

      if (!id) {
        throw new Error(`bookmark id is required, which id is ${id}}`);
      }

      this.loading.fetchBookmark = true;

      try {
        const res = await getBookmarkDetail({ params: { id } });

        this.formBookmark.bookmarkName = res.bookmarkName;
        this.formBookmark.remark = res.remark;

        this.recoverConfig(res);

        this.backup$Data();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading.fetchBookmark = false;
      }
    },

    async fetchComponentInfo() {
      try {
        const { id } = this.formComponent;
        const retData = await getComponentList({ params: { id } });
        if (!retData || !retData.length) return;

        Object.assign(this.formComponent, retData[0]);
        const params = this.formComponent.analysisModelDetailVO || {};

        this.recoverConfig(params);

        this.backup$Data();
      } catch (e) {
        console.error(e);
      }
    },

    async fetchBoardInfo() {
      try {
        const res = await getBoardDetail({ params: { boardId: this.formComponent.boardId } });
        this.boardInfo = res;
        if (!this.boardInfo.componentList) {
          this.boardInfo.componentList = [];
        }
        if (!this.boardInfo.globalConditionConfigVO) {
          this.boardInfo.globalConditionConfigVO = {};
        }
      } catch (e) {
        console.error(e);
      }
    },

    // 把数据还原成页面的配置
    recoverConfig(res) {
      const pickRes = pick(res, [
        'id',
        'attributionType',
        'dateInfo',
        'compareDateInfo',
        'targetEvent',
        'toAttributeEvent',
        'preAssociatedEvent',
        'windowPeriod',
        'windowUnit',
        'isDirectTransform',
        'connectors',
        'conditionModels',
        'packageId',
      ]); // 因为查询书签时，返回了很多其他字段，所以这里要pick一下
      const formData = this.dataToForm(pickRes);
      this.formValue = formData;
    },

    validConfig() {
      const query = this.formValue;
      let validRet = true;
      if (!query.targetEvent.eventName || !query.targetEvent.eventTargetColumn.type) {
        this.$message.warning('目标事件配置不完整');
        validRet = false;
        return validRet;
      }
      if (query.toAttributeEvent.length <= 0) {
        this.$message.warning('待归因事件不能为空');
        validRet = false;
        return validRet;
      }
      let v1 = false;
      query.toAttributeEvent.forEach(toAttributeEvent => {
        if (!toAttributeEvent.eventName) {
          v1 = true;
        }
      });
      if (v1) {
        this.$message.warning('待归因事件不能为空');
        validRet = false;
        return validRet;
      }
      let v2 = false;
      if (query.preAssociatedEvent.length) {
        query.preAssociatedEvent.forEach(preAssociatedEvent => {
          if (!preAssociatedEvent.eventName) {
            v2 = true;
          }
        });
      }
      if (v2) {
        this.$message.warning('过程事件不能为空');
        validRet = false;
        return validRet;
      }
      let v3 = false;
      query.toAttributeEvent.forEach(toAttributeEvent => {
        const preAssociatedEvent = query.preAssociatedEvent.find(item => item.eventName === toAttributeEvent.eventName);
        if (preAssociatedEvent) {
          v3 = true;
        }
      });
      if (v3) {
        this.$message.warning('待归因事件与过程事件重复');
        validRet = false;
        return validRet;
      }

      if (!query.windowPeriod) {
        this.$message.warning('归因窗口期不能为空');
        validRet = false;
        return validRet;
      }
      query.preAssociatedEvent.forEach(event => {
        const { source, target } = event.associatedProperty;
        if (
          source.column &&
          this.columnNameAndJavaTypeMap[source.column] !== this.columnNameAndJavaTypeMap[target.column]
        ) {
          validRet = false;
        }
      });
      if (!validRet) {
        this.$message.warning('过程事件的关联属性值须相同');
        validRet = false;
        return validRet;
      }
      return validRet;
    },

    async fetchAnalysisData(query) {
      this.loading.fetchData = true;

      let retData;

      try {
        const uuid = await getPollingId({ data: query });
        this.polling = new PollingAction({
          delay: 2000,
          handler: async () => {
            retData = await getTableData({ params: { uuid } });
            if (!retData) return true;
            this.loading.fetchData = false;

            this.tableData = retData;
            this.totalCount = retData.length;
            return false;
          },
        });

        await this.polling.start();

        if (!retData) {
          throw new Error(`retData is ${retData}`);
        }
      } catch (e) {
        console.error(e);
        this.loading.fetchData = false;
      }
    },

    // 接口数据转化为表单数据
    dataToForm(data) {
      if (!data) return {};
      const { windowPeriod, windowUnit, conditionModels, toAttributeEvent, preAssociatedEvent } = data;

      this.windowPeriodType =
        windowPeriod === 1 && windowUnit === 'day' ? DATE_OPTIONS[0].value : DATE_OPTIONS[1].value;

      return {
        ...data,
        toAttributeEvent: toAttributeEvent || [
          {
            eventName: '',
            eventChineseName: '',
            groupBy: '',
            conditionModels: [],
            connectors: 'and',
          },
        ],
        preAssociatedEvent: preAssociatedEvent || [],
        conditionModels: conditionModels || [],
      };
    },

    handleQueryClick() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }
      this.fetchAnalysisData(this.formValue);
    },

    handleGetData() {
      this.fetchAnalysisData(this.formValue);
    },

    async handleSaveBookmark(form) {
      // console.log('handleSaveBookmark');
      try {
        const { id, bookmarkName, remark } = form;
        const params = {
          ...{
            id,
            bookmarkName,
            remark,
          },
          analysisType: 'attribution',
          attributionAnalysisReq: this.formValue,
        };

        this.loading.submitting = true;
        const retData = await saveAsBookmark({ data: params });

        this.$message.success('保存成功');

        this.showBookmarkModal = false;

        this.$router.replace({
          name: 'attributionAnalysis',
          query: {
            bookmarkId: params.id || retData,
          },
        });
      } catch (e) {
        //
      } finally {
        this.loading.submitting = false;
      }
    },

    async handleSaveComponent(type, form) {
      const analysisModelReq = this.formValue;

      const params = {
        analysisType: 'attribution',
        analysisModelReq: JSON.stringify(analysisModelReq),
      };

      const propArr = ['id', 'name', 'boardId', 'chartType', 'size', 'remark', 'ext'];

      const tmpObj = pick(form, propArr);
      Object.assign(params, tmpObj);

      // console.log('handleSaveComponent params', params);

      // eslint-disable-next-line no-unused-vars
      let retData;
      try {
        this.loading.submitting = true;

        if (type === 'new') {
          await createComponent({ data: params });
        } else {
          await modifyComponent({ data: params });
        }

        this.$message.success('保存成功');
        this.showBookmarkModal = false;

        setTimeout(() => {
          this.$router.replace({
            name: 'OverviewHome',
            query: {
              boardId: params.boardId,
            },
          });
        }, 100);
      } finally {
        this.loading.submitting = false;
      }
    },

    handleChangeWindowPeriod(value) {
      if (value === DATE_OPTIONS[0].value) {
        this.formValue.windowPeriod = 1;
        this.formValue.windowUnit = 'day';
      } else if (value === DATE_OPTIONS[1].value) {
        this.formValue.windowPeriod = 7;
        this.formValue.windowUnit = 'day';
      }
    },

    handleChangeWindowUnit(value) {
      if (value === 'hour' && this.formValue.windowPeriod > 360) {
        this.formValue.windowPeriod = 360;
      }
    },

    handleAddGlobalFilterItem() {
      if (this.formValue.conditionModels.length >= 5) {
        this.$message.warning('最多添加5个筛选项');
        return;
      }
      this.formValue.conditionModels.push({
        column: '',
        conditionOperator: '',
        value: undefined,
      });
    },

    handleSizeChange(size) {
      this.pageSize = size;
    },

    handleCurrentChange(page) {
      this.currentPage = page;
    },

    formatPercent(value) {
      if (+value !== value) return value;
      return `${(+value * 100).toFixed(2)}%`;
    },

    backup$Data() {
      this.$set(this.resetData, 'formValue', JSON.parse(JSON.stringify(this.formValue)));
      this.resetData.windowPeriodType = this.windowPeriodType;
    },

    handleReset() {
      this.isDoReset = true;
      const { formValue, windowPeriodType } = JSON.parse(JSON.stringify(this.resetData));

      if (formValue.attributionType === undefined) {
        formValue.attributionType =
          this.formOption.typeOptions && this.formOption.typeOptions.length > 0
            ? this.formOption.typeOptions[0].value
            : undefined;
      }
      this.$set(this.$data, 'formValue', formValue);
      this.windowPeriodType = windowPeriodType;
      // this.refreshCount += 1;
      this.$nextTick(() => {
        this.isDoReset = false;
      });
    },

    handleBack() {
      this.$router.replace({
        name: 'OverviewHome',
        query: {
          boardId: this.formComponent.boardId,
        },
      });
    },

    handleGlobalFilterTitleChange() {
      this.canAutoModifyGlobalFilterTitle = !this.globalFilterTitle;
      if (this.canAutoModifyGlobalFilterTitle) {
        this.globalFilterTitle =
          this.formValue.conditionModels
            .map(item => item.value)
            .filter(item => !!item)
            .join(',') || '全体用户';
      }
    },

    async checkGuide() {
      const me = this;
      const code = 'CustomZone.GuiyinAnalysis.FirstVisit';
      this.guideDriver = this.initGuideDriver({
        onReset() {
          me.setVisitedStatus(code, 1);
        },
      });
      this.initGuideSteps();
      const isVisited = await this.getVisitedStatus(code);
      if (!isVisited) {
        this.guideDriver.start();
      }
    },

    initGuideSteps() {
      const me = this;
      const { guideDriver } = this;
      guideDriver.defineSteps([
        {
          element: '.new-guide-step-1',
          popover: {
            className: 'first-step-popover-class',
            closeBtnText: '跳过(1/5)',
            title: '这里可选择一个目标转化事件，一般是与收益相关的事件（比如广告或坑位带来的销售额）',
            description: '这里可选择一个目标转化事件，一般是与收益相关的事件（比如广告或坑位带来的销售额）',
          },
        },
        {
          element: '.new-guide-step-2',
          popover: {
            closeBtnText: '跳过(2/5)',
            title: '这里可选择对目标事件有贡献的事件（比如广告渠道或坑位）',
            description: '这里可选择对目标事件有贡献的事件（比如广告渠道或坑位）',
          },
        },
        {
          element: '.new-guide-step-3',
          popover: {
            closeBtnText: '跳过(3/5)',
            title: '这里可选择不同的归因类型模型，来评估不同渠道对目标事件的贡献率',
            description: '这里可选择不同的归因类型模型，来评估不同渠道对目标事件的贡献率',
          },
        },
        {
          element: '.new-guide-step-4',
          popover: {
            closeBtnText: '跳过(4/5)',
            title: '这里可限定待归因事件到目标转化事件之间的最长时间',
            description: '这里可限定待归因事件到目标转化事件之间的最长时间',
          },
        },
        {
          element: '.new-guide-step-5',
          popover: {
            closeBtnText: '跳过(5/5)',
            title: '这里可对全部事件添加筛选项，选择参与人群，并为分析结果选择维度来分组',
            description: '这里可对全部事件添加筛选项，选择参与人群，并为分析结果选择维度来分组',
          },
          onNext() {
            me.highlightTriggerElement();
          },
        },
      ]);
    },

    handleStartGuide() {
      this.guideDriver.start();
    },
    exportData() {
      // const fileName = `腾讯有数-归因分析结果-${dayjs().format('YYYY-MM-DD')}.xlsx`;

      let tmpGroupBy = [];
      this.formValue.toAttributeEvent.forEach(item => {
        if (item.groupBy) {
          const findProperty = this.formOption.conditionPropertyOptions.find(i => i.propertyName === item.groupBy);
          tmpGroupBy.push({
            val: item.groupBy,
            label: findProperty ? findProperty.propertyDesc : '未知属性',
          });
        }
      });
      tmpGroupBy = lodash.uniqBy(tmpGroupBy, 'val');

      const formatPercent = value => {
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(value)) return value;
        return `${(+value * 100).toFixed(2)}%`;
      };

      const fileName = '分析结果.xlsx';
      const data = [];
      const worksheetMerge = [];
      const col1Num = tmpGroupBy.length > 0 ? tmpGroupBy.length - 1 : 0;
      worksheetMerge.push({
        s: { r: 0, c: 0 },
        e: { r: 0, c: col1Num },
      });
      worksheetMerge.push({
        s: { r: 0, c: col1Num + 1 },
        e: { r: 0, c: col1Num + 4 },
      });
      worksheetMerge.push({
        s: { r: 0, c: col1Num + 5 },
        e: { r: 0, c: col1Num + 6 },
      });
      data.push(['待归因条件', ...tmpGroupBy.map(item => ''), '触发情况', '', '', '', '转化效果', '']);
      data.push([
        '待归因事件',
        ...tmpGroupBy.map(item => item.label),
        '总触发次数',
        '有效触发次数',
        `${this.eventTargetColumn.type.label || ''}${this.eventTargetColumn.calc.label || ''}`,
        '贡献占比',
      ]);
      this.tableData.forEach(row => {
        data.push([
          row.action_type || '',
          ...tmpGroupBy.map(item => row[item.val] || ''),
          row.totalCount,
          row.enabledTotalCount,
          row.totalAmt,
          formatPercent(row.proportion),
        ]);
      });
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      worksheet['!merges'] = worksheetMerge;
      XLSX.utils.book_append_sheet(workbook, worksheet, '归因分析数据');
      XLSX.writeFile(workbook, fileName);
    },
  },
};
</script>

<style scoped lang="less">
@import 'ascribeAnalysis.less';
</style>
